import React, { useEffect, useReducer, useState } from "react";
import { Add } from "@material-ui/icons";
import moment from "moment";
import { ActivityType } from "../../constants/CoreConstants";
import DateFnsUtils from '@date-io/date-fns';
import Grid from '@material-ui/core/Grid';
import {
  getCalendarWidgetDetails,
  getCalendarWidgets,
  getUserConnectedCalendarList,
  getUserGroup,
  saveActivityFollowup
} from "./../../api/globalApi";
import Utils from '../../helpers/Utils';
import GlobalModal from '../GlobalModal/Modal/GlobalModal';
import Select from 'react-select'
import { MuiPickersUtilsProvider, } from '@material-ui/pickers';
import SearchMenu from '../layouts/SearchMenu';
import "./new_activity.css"
import axis from "axis.js";
import BasicInput from "../custom/BasicInput";
import BasicSelect from "../custom/BasicSelect";
import { StyledKeyboardDatePicker, StyledKeyboardTimePicker } from "./StyledComponent";
import EmailSendSkeleton from "../SendComponents/Email/pages/EmailSendSkeleton";
import GlobalModalForActivity from "./Modal/GlobalModalForActivity";


let timingArray = [{ id: 5, title: '5 Minutes' }, { id: 15, title: '15 Minutes' }, { id: 30, title: '30 Minutes' }, { id: 45, title: '45 Minutes' }
  , { id: 60, title: '1 Hour' }, { id: 120, title: '2 Hours' }, { id: 360, title: '6 Hours' }, { id: 720, title: '12 Hours' }]
  const imgSrc = `${process.env.REACT_APP_CDN_LINK}assets/images/releases/calendar/1.0.0/calendar_icon.png`;

const ActivityModal = props => {

  const reducerFunction = (state, data) => {
    switch (data.type) {

      case 'updateDataList':
        return { ...state, ...data.payload }
      default:
        return data.payload;
    }
  }

  let durationOptions = [];

  for (let i = 0; i < 36; i++) {
    for (let j = 0; j < 4; j++) {
      let hours = String(i).padStart(2, '0');
      let minutes = String(j * 15).padStart(2, '0');
      let time = `${hours}:${minutes}`;
      durationOptions.push({
        label: time,
        value: time
      });
    }
  }


  const [activityInformation, dispatchActivityInformation] = useReducer(reducerFunction,
    {
      "activityTitle": '', "activityDescription": '', 'activityTime': moment(new Date()), "activityDuration": '00:30',
      'activityType': ActivityType.CALL, "activityDate": moment().toDate(), "selectedUser": '', "selectedWidget": '',
      'editActivityId': null, "invitationToAttendee": null, "remindMeBefore": '30', "remindMe": false,
      'selectedContactId': null, 'selectedContactEmail': null, 'selectedContactNumber': null,
      'selectedContactFullName': null, 'sendEmail': false, 'smsText': '', 'sendSms': false, 'calendarWidgetId': null, 'connectedCalendarId': ''
    })

  const [submitting, setSubmitting] = useState(false)
  const [teamUsers, setTeamUsers] = useState([]);
  const [calendarWidgets, setCalendarWidgets] = useState([]);
  const [maxDate, setMaxDate] = useState(moment().add(365, "days"));
  const [minDate, setMinDate] = useState(moment().subtract(365, "days"));
  const [calendarWidgetId, setCalendarWidgetId] = useState(null);
  const [duration, setDuration] = useState(0);
  const [reserveSlots, setReserveSlots] = useState([]);
  const [availabilityIncrements, setAvailabilityIncrements] = useState(30);
  const [dateRange, setDateRange] = useState([]);
  const [schedules, setSchedules] = useState([]);
  const [timeZone, setTimeZone] = useState('America/Los_Angeles');
  const [selectedTime, setSelectedTime] = useState(null);
  const [titleValidation, setTitleValidation] = useState(false); // eslint-disable-line no-unused-vars
  const [userConnectedList, setUserConnectedList] = useState([])
  const [calendarError, setCalendarError] = useState(false)


  let activityModalDateTime;

  const [editId, setEditId] = useState(null);
  useEffect(() => {
    getUserConnectedCalenderData()
  }, [])

  useEffect(() => {
    fetchUsersList();

    fetchCalendarWidgetList();

    fetchContactInfo();

    let userTimelineRaw = Utils.getAccountData('userTimezoneRaw');
    let updateInfos = {};
    try {
      let slotInfo = props.slotInfo;
      if (slotInfo.start !== undefined) {
        let formattedDate = moment(slotInfo.start, "YYYY-MM-DDTHH:mm:ssZ").toDate();
        // setActivityDate(formattedDate);
        updateInfos['activityDate'] = formattedDate;
      }

      if (slotInfo.taskId !== undefined) {
        // setActivityType(slotInfo.taskId);
        updateInfos['activityType'] = slotInfo.taskId;
      }


      if (slotInfo.title !== undefined)
        // setActivityTitle(slotInfo.title);
        updateInfos['activityTitle'] = slotInfo.title ?? '';

      if (slotInfo.taskNote !== undefined)
        // setActivityDescription(slotInfo.taskNote);
        updateInfos['activityDescription'] = slotInfo.taskNote ?? '';


      if (slotInfo.taskTime !== undefined) {
        if (slotInfo.taskTime.search("PM")) {

          activityModalDateTime = moment(slotInfo.taskTime, [moment.ISO_8601, 'HH:mm']); // eslint-disable-line react-hooks/exhaustive-deps

          var newTime = moment(activityModalDateTime).format('HH:mm');
          var timeArray = newTime.split(":");

          // setActivityTime(parseInt(timeArray[0]) + 12 +':'+timeArray[1]);
          updateInfos['activityTime'] = parseInt(timeArray[0]) + 12 + ':' + timeArray[1];

        } else {
          activityModalDateTime = moment(slotInfo.taskTime, [moment.ISO_8601, 'HH:mm']);

          // setActivityTime(moment(activityModalDateTime).format('HH:mm'));
          updateInfos['activityTime'] = moment(activityModalDateTime).format('HH:mm');

        }
      }

      if (slotInfo.taskDuration !== undefined)
        // setActivityDuration(slotInfo.taskDuration);
        updateInfos['activityDuration'] = slotInfo.taskDuration;

      if (slotInfo.contactId)
        // setSelectedContactId(slotInfo.contactId);
        updateInfos['selectedContactId'] = slotInfo.contactId;

      if (slotInfo.contactNumber)
        // setSelectedContactNumber(slotInfo.contactNumber);
        updateInfos['selectedContactNumber'] = slotInfo.contactNumber;

      if (slotInfo.email)
        // setSelectedContactEmail(slotInfo.email);
        updateInfos['selectedContactEmail'] = slotInfo.email;


      if (slotInfo.name !== undefined)
        // setSelectedContactFullName(slotInfo.name);
        updateInfos['selectedContactFullName'] = slotInfo.name;

      if (slotInfo.assigned_to !== undefined)
        // setSelectedUser(slotInfo.assigned_to);
        updateInfos['selectedUser'] = slotInfo.assigned_to;

      if (slotInfo.reminder_time_period !== undefined)
        // setRemindMeBefore(slotInfo.reminder_time_period);
        updateInfos['remindMeBefore'] = slotInfo.reminder_time_period;

      if (slotInfo.attendence !== undefined)
        // setInvitationToAttendee(slotInfo.attendence);
        updateInfos['invitationToAttendee'] = slotInfo.attendence;

      if (slotInfo.notify_by_email !== undefined)
        // setSendEmail(slotInfo.notify_by_email);
        updateInfos['sendEmail'] = slotInfo.notify_by_email;


      if (slotInfo.id !== undefined) {
        updateInfos['editActivityId'] = slotInfo.id;
        setEditId(slotInfo.id)
      }
      // setEditActivityId(slotInfo.id);



      let editData = props.editData


      if (editData !== undefined && editData != null) {
        if (props.from !== undefined && props.from === "contactDetails-activity-tab") {
          try {

            let formattedDate = moment(editData.taskDate + ' ' + editData.taskRawTime, "YYYY-MM-DDTHH:mm:ssZ").toDate();
            //    setActivityDate(formattedDate);
            updateInfos['activityDate'] = formattedDate;

            // setActivityDate(window.globalTimezoneConversionToDifferentTimezone(editData.taskDate+' '+editData.taskRawTime,'UTC', userTimelineRaw));
          } catch (e) {
            console.log('time convert :' + e)

          }
          //    setActivityTitle(editData.title);
          updateInfos['activityTitle'] = editData.title ?? '';

          // setActivityDescription(editData.taskNote);
          updateInfos['activityDescription'] = editData.taskNote ?? '';

          // setActivityType(editData.taskId);
          updateInfos['activityType'] = editData.taskId;

          // setActivityTime(window.globalTimezoneConversionToDifferentTimezone(editData.taskDate+' '+editData.taskRawTime,'UTC', userTimelineRaw));
          updateInfos['activityTime'] = window.globalTimezoneConversionToDifferentTimezone(editData.taskDate + ' ' + editData.taskRawTime, 'UTC', userTimelineRaw);

          // setActivityDuration(editData.taskDuration.replace(/:00([^:00]*)$/, '$1'));
          updateInfos['activityDuration'] = editData.taskDuration.replace(/:00([^:00]*)$/, '$1')

          // setSelectedContactId(editData.contactId);
          updateInfos['selectedContactId'] = editData.contactId;

          // setSelectedContactNumber(editData.contactNumber);
          updateInfos['selectedContactNumber'] = editData.contactNumber;

          // setSelectedContactEmail(editData.email);
          updateInfos['selectedContactEmail'] = editData.email;

          // setSelectedContactFullName(editData.name);
          updateInfos['selectedContactFullName'] = editData.name;

          // setSelectedUser(editData.assigned_to);
          updateInfos['selectedUser'] = editData.assigned_to ?? '';

          // setRemindMeBefore(editData.reminder_time_period == null ? 30 : editData.reminder_time_period);
          updateInfos['remindMeBefore'] = editData.reminder_time_period ?? 30;

          // setSendEmail(editData.notify_by_email == 0 ? false : true); // eslint-disable-line eqeqeq
          updateInfos['sendEmail'] = editData.notify_by_email == 0 ? false : true; // eslint-disable-line eqeqeq

          // setEditActivityId(editData.id);
          updateInfos['editActivityId'] = editData.id;
          setEditId(editData.id)
        }
        else {
          // setActivityTitle(editData.task_title ? editData.task_title : editData.title ? editData.title : '');
          updateInfos['activityTitle'] = editData.task_title ?? editData.title ?? '';

          // setActivityDescription(editData.note ? editData.note : editData.taskNote ? editData.taskNote : '');
          updateInfos['activityDescription'] = editData.note ?? editData.taskNote ?? '';

          // setActivityType(editData.task_id ? editData.task_id : editData.taskId ? editData.taskId : ActivityType.CALL);
          updateInfos['activityType'] = editData.task_id ?? editData.taskId ?? ActivityType.CALL;

          if (props.activityFrom === '') {
            try {
              if (editData.date !== undefined && editData.date != null) {
                // setActivityDate(window.globalTimezoneConversionToDifferentTimezone(editData.date+' '+editData.time,'UTC',userTimelineRaw,"YYYY-MM-DD"));
                updateInfos['activityDate'] = window.globalTimezoneConversionToDifferentTimezone(editData.date + ' ' + editData.time, 'UTC', userTimelineRaw);

                // setActivityTime(window.globalTimezoneConversionToDifferentTimezone(editData.date+' '+editData.time,'UTC', userTimelineRaw));
                updateInfos['activityTime'] = window.globalTimezoneConversionToDifferentTimezone(editData.date + ' ' + editData.time, 'UTC', userTimelineRaw);
              } else if (editData.taskDate !== undefined && editData.taskDate != null) {
                // setActivityTime(moment(editData.taskDate+' '+editData.taskTime,'YYYY-MM-DD HH:mm:ss'));
                updateInfos['activityTime'] = moment(editData.taskDate + ' ' + editData.taskTime, 'YYYY-MM-DD HH:mm:ss')
                // setActivityDate(moment(editData.taskDate+' '+editData.taskRawTime, "YYYY-MM-DDTHH:mm:ssZ").toDate());
                updateInfos['activityDate'] = moment(editData.taskDate + ' ' + editData.taskRawTime, "YYYY-MM-DDTHH:mm:ssZ").toDate();

              }
            } catch (e) {
              console.log('time convert :' + e)
            }
          } else if (props.activityFrom === 'dashboard') {
            // setActivityTime(window.globalTimezoneConversionToDifferentTimezone(editData.date+' '+editData.time,'UTC', userTimelineRaw));
            // setActivityTime(window.globalTimezoneConversionToDifferentTimezone(editData.date_time,'UTC', userTimelineRaw));
            updateInfos['activityTime'] = window.globalTimezoneConversionToDifferentTimezone(editData.date_time, 'UTC', userTimelineRaw)
            // setActivityDate(moment(editData.date+' '+editData.time, "YYYY-MM-DDTHH:mm:ssZ").toDate());
            // setActivityDate(window.globalTimezoneConversionToDifferentTimezone(editData.date_time,'UTC', userTimelineRaw));
            updateInfos['activityDate'] = window.globalTimezoneConversionToDifferentTimezone(editData.date_time, 'UTC', userTimelineRaw);
          } else if (props.activityFrom === 'calendar') {
            // setActivityDate(window.globalTimezoneConversionToDifferentTimezone(editData.taskDate+' '+editData.taskRawTime,'UTC',userTimelineRaw,"YYYY-MM-DD"));
            updateInfos['activityDate'] = window.globalTimezoneConversionToDifferentTimezone(editData.taskDate + ' ' + editData.taskRawTime, 'UTC', userTimelineRaw);
            // setActivityTime(window.globalTimezoneConversionToDifferentTimezone(editData.taskDate+' '+editData.taskRawTime,'UTC', userTimelineRaw));
            updateInfos['activityTime'] = window.globalTimezoneConversionToDifferentTimezone(editData.taskDate + ' ' + editData.taskRawTime, 'UTC', userTimelineRaw);
          } else if (props.activityFrom === 'inbox') {
            // setActivityDate(window.globalTimezoneConversionToDifferentTimezone(editData.taskDate+' '+editData.taskRawTime,'UTC',userTimelineRaw,"YYYY-MM-DD"));
            updateInfos['activityDate'] = window.globalTimezoneConversionToDifferentTimezone(editData.date_time, 'UTC', userTimelineRaw);
            // setActivityTime(window.globalTimezoneConversionToDifferentTimezone(editData.taskDate+' '+editData.taskRawTime,'UTC', userTimelineRaw));
            updateInfos['activityTime'] = window.globalTimezoneConversionToDifferentTimezone(editData.date_time, 'UTC', userTimelineRaw);
          }



          // setActivityDuration(editData.duration);
          try {
            // setActivityDuration(editData.duration? editData.duration.replace(/:00([^:00]*)$/, '$1') : 
            // editData.taskDuration? editData.taskDuration : '00:30');

            updateInfos['activityDuration'] = editData.duration ? editData.duration.replace(/:00([^:00]*)$/, '$1') :
              editData.taskDuration ?? '00:30'
          } catch (e) {
            console.log('duration convert :' + e)

          }

          if (editData.contact_id !== undefined && editData.contact_id != null && editData.contact !== undefined &&
            editData.contact != null) {
            // setSelectedContactId(editData.contact_id);
            updateInfos['selectedContactId'] = editData.contact_id;

            // setSelectedContactNumber(editData.contact?.number);
            updateInfos['selectedContactNumber'] = editData.contact?.number
            // setSelectedContactEmail(editData.contact?.email);

            updateInfos['selectedContactEmail'] = editData.contact?.email
            if (editData.contact && editData.contact.name !== undefined) {
              // setSelectedContactFullName(editData.contact.name);
              updateInfos['selectedContactFullName'] = editData.contact?.name
            }
            if (editData.contact.first_name && editData.contact.last_name) {
              // setSelectedContactFullName(editData.contact?.first_name + ' ' + editData.contact?.last_name);
              updateInfos['selectedContactFullName'] = editData.contact?.first_name + ' ' + editData.contact?.last_name
            }

          }

          if (editData.contactId !== undefined && editData.contactId != null) {
            updateInfos['selectedContactId'] = editData.contactId;

            if (editData.contactNumber) {
              updateInfos['selectedContactNumber'] = editData.contactNumber;
            }

            if (editData.email) {
              updateInfos['selectedContactEmail'] = editData.email;
            }

            if (editData.name) {
              updateInfos['selectedContactFullName'] = editData.name
            }
          }

          // setSelectedUser(editData.assigned_to ?? '');
          updateInfos['selectedUser'] = editData.assigned_to ?? '';

          // setRemindMeBefore(editData.reminder_time_period ?? 30);
          updateInfos['remindMeBefore'] = editData.reminder_time_period ?? 30;

          // setInvitationToAttendee((editData.send_invitation_to_attendence && editData.send_invitation_to_attendence != 0) ? true : false); // eslint-disable-line eqeqeq
          updateInfos['invitationToAttendee'] = (editData.send_invitation_to_attendence && editData.send_invitation_to_attendence != 0) ? true : false;

          // setSendEmail((editData.notify_by_email && editData.notify_by_email != 0) ? true : false); // eslint-disable-line eqeqeq
          updateInfos['sendEmail'] = (editData.notify_by_email && editData.notify_by_email != 0) ? true : false; // eslint-disable-line eqeqeq
          updateInfos['editActivityId'] = editData.id;
          updateInfos['calendarWidgetId'] = editData.calendar_widget_id != undefined ? editData.calendar_widget_id : null;
          setEditId(editData.id)

          // setEditActivityId(editData.id);
        }
      }

      if (!props.showAll) {
        // setActivityType(ActivityType.APOINTMENT)
        updateInfos['activityType'] = ActivityType.APOINTMENT
      }
    } catch (e) {
      console.log('useEffect problem : ' + JSON.stringify(e))
    }
    dispatchActivityInformation({ 'type': 'updateDataList', 'payload': updateInfos })


  }, []);


  useEffect(() => {
    onDatePicked(activityInformation.activityDate);
  }, [schedules])

  const fetchContactInfo = () => {
    if (props.people != null) {

      let tempUpdateInfo = {}
      // setSelectedContactId(props.people.id);
      tempUpdateInfo['selectedContactId'] = props.people.id;

      // setSelectedContactEmail(props.people.email);
      tempUpdateInfo['selectedContactEmail'] = props.people.email

      // setSelectedContactNumber(props.people.value);
      tempUpdateInfo['selectedContactNumber'] = props.people.value

      // setSelectedContactFullName(props.people.first_name+' '+props.people.last_name);
      tempUpdateInfo['selectedContactFullName'] = props.people.first_name + ' ' + props.people.last_name
      dispatchActivityInformation({ 'type': 'updateDataList', 'payload': tempUpdateInfo })

    }
  }

  const onSelectContactForElastic = (param) => {

    let full_name;

    let tempUpdateInfo = {};
    tempUpdateInfo['selectedContactId'] = param.id;

    if (param.email && param.email !== "") {
      tempUpdateInfo['selectedContactEmail'] = param.email

    }
    if (param.number && param.number !== "") {
      tempUpdateInfo['selectedContactNumber'] = param.number

    }

    if (param.firstName && param.firstName !== "") {
      full_name = param.firstName
    }
    if (param.lastName && param.lastName !== "") {
      full_name += ' ' + param.lastName
    }

    tempUpdateInfo['selectedContactFullName'] = full_name
    dispatchActivityInformation({ 'type': 'updateDataList', 'payload': tempUpdateInfo })

  }

  const startLoader = () => {

    let modalWidth = document.querySelector('.activity__modal_overflow').offsetWidth;
    document.querySelector(".activity__modal_overflow").style.width = modalWidth + 'px';
    setSubmitting(true)
  }

  const goToInitialSearchValue = () => {
    dispatchActivityInformation({ 'type': 'updateDataList', 'payload': { 'selectedContactId': "" } })
  }

  const submitActivityInformation = () => {
    if (activityInformation.activityTitle !== '' && activityInformation.activityTitle.length < 250) {
      if (!submitting) {
        if (activityInformation.sendSms && activityInformation.smsText.length === 0) {
          window.showNotification('WARNING', "Please type the message text.")
          return
        }
        startLoader()
        let formData = new FormData();

        formData.append('closeDate', moment(activityInformation.activityDate).format("MM/DD/YYYY"));
        formData.append('date', moment(activityInformation.activityDate).format("MM/DD/YYYY"));

        formData.append('note', activityInformation.activityDescription);
        formData.append('notify_by_email', activityInformation.sendEmail);
        formData.append('reminder', activityInformation.remindMe);
        formData.append('reminder_time_period', activityInformation.remindMeBefore);
        formData.append('send_invitation_to_attendence', activityInformation.invitationToAttendee);
        formData.append('task_id', activityInformation.activityType);
        formData.append('task_title', activityInformation.activityTitle);

        if (props.moreData && props.moreData.userId) {
          formData.append('userId', props.moreData.userId);

        }
        if (selectedTime) {
          formData.append('time', selectedTime);
          formData.append('duration', duration);
        } else {
          formData.append('time', moment(activityInformation.activityTime).format("HH:mm"));
          formData.append('duration', activityInformation.activityDuration);
        }

        /* for sms send */
        formData.append('sendSms', activityInformation.sendSms);
        formData.append('smsText', activityInformation.smsText);

        if (activityInformation.selectedUser != null) {
          formData.append('assigned_to', activityInformation.selectedUser);
        }

        if (activityInformation.selectedWidget != null) {
          formData.append('calendar_id', activityInformation.selectedWidget);
        }

        if (activityInformation.calendarWidgetId != null) {
          formData.append('calendar_id', activityInformation.calendarWidgetId);
        }

        if (activityInformation.selectedContactId != null) {
          formData.append('contact_id', activityInformation.selectedContactId);
        }

        if (activityInformation.editActivityId != null) {
          formData.append('id', activityInformation.editActivityId);
        }
        if (activityInformation.connectedCalendarId !== '') {
          formData.append('connected_calendar_id', activityInformation.connectedCalendarId)
        }

        if (activityInformation.editActivityId == null && activityInformation.connectedCalendarId === '' && activityInformation.invitationToAttendee) {
          window.showNotification('ERROR', "Calendar field is required!")
          setCalendarError(true)
          setSubmitting(false)
        }
        else {
          saveActivityFollowup(formData).then(res => {
            setSubmitting(false)

            if (res.data.data.status) {

              window.showNotification('SUCCESS', res.data.data.html)
              if (props.callBack !== undefined && props.callBack != null) {
                props.callBack();
              }
              props.closeActivityModel();


            } else {
              window.showNotification('ERROR', "Something went wrong!")
            }
          });
        }
      }
      else {
        window.showNotification('ERROR', "Activity updating...")
      }
    }
    else if (activityInformation.activityTitle === '') {
      window.showNotification('ERROR', "Title can not be empty")
    }
    else {
      window.showNotification('ERROR', "Title is too long")
    }
  }

  const fetchUsersList = async () => {


    if (props.subUserList != null) {
      // props.setSubUserList(props.subUserList)
      setTeamUsers(props.subUserList)
    } else {
      await getUserGroup()
        .then(response => {

          // props.setSubUserList(response.data.data)
          setTeamUsers(response.data.data)
        })
        .catch(error => {
          console.log('something is wrong' + error)
        });
    }

  }

  const fetchCalendarWidgetList = async () => {
    await getCalendarWidgets({ userId: (props.moreData && props.moreData.userId) ?? null })
      .then(response => {
        setCalendarWidgets(response.data.data)

      })
      .catch(error => {
        console.log('something is wrong' + error)
      });
  }

  const getSelectedCalendarWidgetDetails = async (calendarWidgetId) => {
    await getCalendarWidgetDetails({ calendarWidgetId: calendarWidgetId })
      .then(response => {
        console.log(response.data.data.schedules)
        setDuration(response.data.data.duration);
        setAvailabilityIncrements(response.data.data.availability_increments);
        setSchedules(response.data.data.schedules);
        setTimeZone(response.data.data.user.timezone);
        processReserveSlot(response.data.data.reserved_slots);

      })
      .catch(error => {
        console.log('something is wrong' + error)
      });
  }

  const processReserveSlot = (reserved_slots) => {

    let reserveSlots = {};

    reserved_slots.map((each) => {
      if (moment(each.slot_start_time, ['YYYY-MM-DD h:m']).format('YYYY-M-D') in reserveSlots) {
        reserveSlots[moment(each.slot_start_time, ['YYYY-MM-DD h:m']).format('YYYY-M-D')].push({ start: moment(each.slot_start_time, ['YYYY-MM-DD h:m']).format('h:mma'), end: moment(each.slot_end_time, ['YYYY-MM-DD h:m']).format('h:mma') })
      } else {
        reserveSlots[moment(each.slot_start_time, ['YYYY-MM-DD h:m']).format('YYYY-M-D')] = [];
        reserveSlots[moment(each.slot_start_time, ['YYYY-MM-DD h:m']).format('YYYY-M-D')].push({ start: moment(each.slot_start_time, ['YYYY-MM-DD h:m']).format('h:mma'), end: moment(each.slot_end_time, ['YYYY-MM-DD h:m']).format('h:mma') })
      }
    });

    setReserveSlots(reserveSlots);

    return reserveSlots;

  }

  const onDatePicked = (res) => {
    setSelectedTime(null);
    if (calendarWidgetId) {
      const D = moment(res, ['YYYY-MM-DD h:m']).format("D");
      const M = moment(res, ['YYYY-MM-DD h:m']).format("M");
      const Y = moment(res, ['YYYY-MM-DD h:m']).format("Y");

      const Selected = schedules.filter((each) => {
        if (moment(each.start, ['YYYY-MM-DD h:m']).format('D') === D && moment(each.start, ['YYYY-MM-DD h:m']).format('M') === M && moment(each.start, ['YYYY-MM-DD h:m']).format('Y') === Y) {
          return each;
        }
      });
      setDateRange(Selected);
    }

  };

  const updateActivityType = (value, key) => {
    dispatchActivityInformation({ 'type': 'updateDataList', 'payload': { [key]: value } })
  }

  const updateActivityTypeDateSelect = (value, key) => {
    dispatchActivityInformation({ 'type': 'updateDataList', 'payload': { [key]: value } })
    onDatePicked(value);
  }

  const updateActivityTypeForCalendarWidget = (value, key) => {
    dispatchActivityInformation({ 'type': 'updateDataList', 'payload': { [key]: value } })
    setCalendarWidgetId(value);
    if (value != null && value != '') {
      getSelectedCalendarWidgetDetails(value);
    } else {
      // setMaxDate(moment().add(60, "days"));
      // setMinDate(moment().subtract(60, "days"));
    }
  }

  const generateScheduleTimeList = () => {
    let lists = [];
    for (let schedule in dateRange) {

      if (axis.isObject(dateRange[schedule])) {
        let date = moment(dateRange[schedule].start, ['YYYY-MM-DD']).format('YYYY-M-D');
        let start = dateRange[schedule].title.split('-')[0];
        let end = dateRange[schedule].title.split('-')[1];

        do {
          let time = moment(start, ['h:m a', 'H:m']).format('h:mma');
          let slotStart = moment(start, ['h:m a', 'H:m']);
          let slotEnd = moment(start, ['h:m a', 'H:m']).add(availabilityIncrements, 'm');
          if (date in reserveSlots) {

            let isExist = reserveSlots[date].filter((reserveTime) => {
              let reserveStartTime = '';
              let reserveEndTime = '';

              reserveStartTime = reserveTime.start;
              reserveEndTime = reserveTime.end;

              let startDate = moment(reserveStartTime, ['h:m a', 'H:m']);
              let endDate = moment(reserveEndTime, ['h:m a', 'H:m']);
              return slotStart.isSame(startDate) || slotStart.isBetween(startDate, endDate) || slotEnd.isBetween(startDate, endDate);
            });

            if (axis.isArray(isExist) && isExist.length === 0) {
              lists.push({
                time: time,
                date: dateRange[schedule].start
              });
            }

          } else {
            lists.push({
              time: time,
              date: dateRange[schedule].start
            });
          }

          start = moment(start, ['h:m a', 'H:m']).add(availabilityIncrements, 'm');
          end = moment(end, ['h:m a', 'H:m']);


        }
        while (start < end);
      }
    }


    let today = moment().format('YYYY-MM-DD');

    return lists.map((data, index) => {

      if (moment(moment(data.date).format('YYYY-MM-DD')).isSame(today)) {
        if (moment(data.time, ['h:m a', 'H:m']) > moment(moment(), ['h:m a', 'H:m'])) {
          return { value: data.time, label: data.time };
        }
      } else {
        return { value: data.time, label: data.time }
      }
    });
  }

  const changeTimeOnCalendarWidget = (selected) => {
    let newTime = '00:30';
    if (selected.value.includes("pm")) {
      newTime = selected.value.replace("pm", "");
      let newTimeArr = newTime.split(':');
      let newTimeHour = parseInt(newTimeArr[0]) + 12;
      newTime = newTimeHour + ':' + newTimeArr[1];
    } else {
      newTime = selected.value.replace("am", "");
    }

    setSelectedTime(newTime);
  }

  const activityClass = "waves-effect py-2 px-3 radius-5 d-flex justify-content-center align-items-center mr-2";
  const timeSelectCustomStyle = {
    control: base => ({
      ...base,
      height: 45,
      minHeight: 35
    }),
  }

  const getUserConnectedCalenderData = async () => {
    await getUserConnectedCalendarList({ userId: (props.moreData && props.moreData.userId) ?? null })
      .then(response => {
        setUserConnectedList(response.data.data)
      })
      .catch(error => {
        console.log('something is wrong' + error)
      });
  }

  return (
    <React.Fragment>
      <GlobalModalForActivity
        open={props.openActivityModal}
        onClose={() => props.closeActivityModel()}
        title={`${props.editData !== undefined && props.editData !== null
          ? "Edit "
          : "New"
          } ${props.showAll ? "Activity" : "Appointment"}`}
        buttonText={`${props.editData !== undefined && props.editData != null
          ? "Update"
          : "Set"
          } ${props.showAll ? " Activity" : " Appointment"}`}
        buttonIcon={<Add />}
        handleSubmit={submitActivityInformation}
        className={"activity__modal_overflow update global-medium-modal"}
        img = {imgSrc}
        hideFooter={submitting}
      >
        {submitting ? (
          <EmailSendSkeleton />) : (
          <div>
            <div id="massaging-service-modal">
              {/* {!submitting && */}

              <div>
                {props.showAll && (
                  <div className="row mb-0">
                    <div className="col s12">
                      <h5 className="text-dark-blue m-0 text-left mb-2" style={{fontWeight:600}}>Select a category for this activity:</h5>
                      <div className="d-flex add_task_top_buttons my-4">
                        <a
                          href="#!"
                          onClick={(e) => {
                            e.preventDefault();
                            updateActivityType(
                              ActivityType.CALL,
                              "activityType"
                            );
                          }}
                          className={`${activityClass} ${activityInformation.activityType ===
                            ActivityType.CALL
                            ? "active-activity-state"
                            : "white text-gray"
                            }`}
                        >
                          <i className="material-icons mr-1">phone_in_talk</i>
                          Call
                        </a>
                        <a
                          href="#!"
                          onClick={(e) => {
                            e.preventDefault();
                            updateActivityType(
                              ActivityType.APOINTMENT,
                              "activityType"
                            );
                          }}
                          className={`${activityClass} ${activityInformation.activityType ===
                            ActivityType.APOINTMENT
                            ? "active-activity-state"
                            : "white text-gray"
                            }`}
                        >
                          <svg
                            className="mr-1 mt-1"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M13.3983 8.64207C13.4443 8.64207 13.4901 8.64207 13.5362 8.64632V3.09375H0.00390625V12.6947C0.00455909 13.4558 0.621456 14.0726 1.38262 14.0734H9.03231C8.96344 13.7578 8.92852 13.4356 8.92787 13.1125C8.93064 10.6447 10.9305 8.64485 13.3983 8.64207ZM3.11646 6.93337H9.59225C9.75366 6.93337 9.88471 7.06425 9.88471 7.22582C9.88471 7.38723 9.75366 7.51828 9.59225 7.51828H3.11646C2.9549 7.51828 2.82401 7.38723 2.82401 7.22582C2.82401 7.06425 2.9549 6.93337 3.11646 6.93337ZM6.99345 10.2339H3.11646C2.9549 10.2339 2.82401 10.1029 2.82401 9.94147C2.82401 9.77991 2.9549 9.64902 3.11646 9.64902H6.99345C7.15502 9.64902 7.28591 9.77991 7.28591 9.94147C7.28591 10.1029 7.15502 10.2339 6.99345 10.2339Z" fill ="currentColor"/>
                            <path d="M13.3972 9.23047C11.2513 9.23047 9.51172 10.97 9.51172 13.1159C9.51172 15.2619 11.2513 17.0014 13.3972 17.0014C15.5431 17.0014 17.2827 15.2619 17.2827 13.1159C17.2809 10.9708 15.5423 9.23226 13.3972 9.23047ZM15.8246 12.1299L13.0504 14.7829C12.9962 14.8341 12.9244 14.8625 12.85 14.8624C12.7723 14.8617 12.6977 14.832 12.6411 14.7788L11.0659 13.1995C10.9518 13.0853 10.9518 12.9 11.0659 12.786C11.1801 12.6717 11.3653 12.6717 11.4796 12.786L12.8541 14.1604L15.4235 11.708C15.4793 11.654 15.5544 11.6245 15.6321 11.6259C15.7097 11.6276 15.7835 11.66 15.8372 11.7163C15.9464 11.8345 15.9408 12.0186 15.8246 12.1299Z" fill ="currentColor"/>
                            <path d="M13.5365 1.37872C13.5357 0.61755 12.9189 0.000652844 12.1578 0H10.3195V0.923225C10.3195 1.08479 10.1886 1.21568 10.027 1.21568C9.86546 1.21568 9.73458 1.08479 9.73458 0.923225V0H3.80192V0.923225C3.80192 1.08479 3.67103 1.21568 3.50946 1.21568C3.34789 1.21568 3.21701 1.08479 3.21701 0.923225V0H1.37872C0.61755 0.000652844 0.000816 0.61755 0 1.37872V2.51508H13.5323V1.37872H13.5365Z" fill ="currentColor"/>
                          </svg>
                          Appointment
                        </a>
                        <a
                          href="#!"
                          onClick={(e) => {
                            e.preventDefault();
                            updateActivityType(
                              ActivityType.TASK,
                              "activityType"
                            );
                          }}
                          className={`${activityClass} ${activityInformation.activityType ===
                            ActivityType.TASK
                            ? "active-activity-state"
                            : "white text-gray"
                            }`}
                        >
                          <svg
                            className="mr-1"
                            width="13"
                            height="17"
                            viewBox="0 0 13 17"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M8.87793 1.24772H7.67322C7.52289 1.24307 7.39372 1.13971 7.35618 0.994116C7.24202 0.401023 6.71285 -0.0205456 6.10924 0.0007735C5.50198 -0.00986585 4.9754 0.41854 4.86229 1.01527C4.82321 1.15686 4.69202 1.25306 4.54525 1.24776H3.38281V3.36127H8.87793V1.24772Z" fill ="currentColor"/>
                            <path d="M12.2586 15.495V3.38463C12.2598 2.90606 11.8729 2.51706 11.3943 2.51576C11.3724 2.51572 11.3505 2.51649 11.3286 2.51807H9.51097V3.59596C9.51097 3.76506 9.40531 3.99755 9.23621 3.99755H3.00139C2.83229 3.99755 2.74779 3.76506 2.74779 3.59596V2.51811H0.930157C0.452883 2.48308 0.0375437 2.84162 0.00255121 3.31893C0.000933063 3.34082 0.000164473 3.36274 0.00024538 3.38467V15.495C-0.0115671 16.0202 0.404581 16.4554 0.929712 16.4672C0.929874 16.4672 0.930036 16.4672 0.930197 16.4672H11.3286C11.8538 16.4557 12.2701 16.0206 12.2586 15.4955C12.2586 15.4953 12.2586 15.4952 12.2586 15.495ZM4.41744 12.7052L2.7689 14.248C2.71619 14.3111 2.63961 14.3494 2.55757 14.3537C2.46926 14.3502 2.38581 14.3123 2.32508 14.248L1.45856 13.3604C1.34339 13.2314 1.35282 13.0339 1.47968 12.9166C1.60294 12.7957 1.80024 12.7957 1.9235 12.9166L2.55753 13.5929L3.99473 12.2402C4.13883 12.1408 4.33629 12.1769 4.43572 12.321C4.51687 12.4386 4.50935 12.5959 4.41744 12.7052ZM4.41744 9.32357L2.7689 10.8664C2.71619 10.9295 2.63961 10.9678 2.55757 10.9721C2.46926 10.9686 2.38581 10.9307 2.32508 10.8664L1.45856 9.97876C1.34339 9.84979 1.35282 9.65234 1.47968 9.53494C1.60294 9.4141 1.80024 9.4141 1.9235 9.53494L2.55753 10.2112L3.99473 8.85859C4.13883 8.75916 4.33629 8.79532 4.43572 8.93942C4.51687 9.05698 4.50935 9.21426 4.41744 9.32357ZM4.41744 5.94196L2.7689 7.48482C2.71619 7.54789 2.63961 7.58616 2.55757 7.59049C2.46926 7.58701 2.38581 7.54906 2.32508 7.48482L1.45856 6.59715C1.34339 6.46818 1.35282 6.27072 1.47968 6.15333C1.60294 6.03249 1.80024 6.03249 1.9235 6.15333L2.55753 6.82963L3.99473 5.47698C4.13883 5.37754 4.33629 5.41371 4.43572 5.55781C4.51687 5.67537 4.50935 5.83265 4.41744 5.94196ZM10.5677 13.931H5.70666C5.53157 13.931 5.38962 13.7891 5.38962 13.614C5.38962 13.4389 5.53157 13.2969 5.70666 13.2969H10.5677C10.7428 13.2969 10.8847 13.4389 10.8847 13.614C10.8847 13.7891 10.7428 13.931 10.5677 13.931ZM10.5677 10.5494H5.70666C5.53157 10.5494 5.38962 10.4074 5.38962 10.2324C5.38962 10.0573 5.53157 9.91533 5.70666 9.91533H10.5677C10.7428 9.91533 10.8847 10.0573 10.8847 10.2324C10.8847 10.4074 10.7428 10.5494 10.5677 10.5494ZM10.5677 7.16779H5.70666C5.53157 7.16779 5.38962 7.02583 5.38962 6.85075C5.38962 6.67567 5.53157 6.53371 5.70666 6.53371H10.5677C10.7428 6.53371 10.8847 6.67567 10.8847 6.85075C10.8847 7.02588 10.7428 7.16779 10.5677 7.16779Z" fill ="currentColor"/>
                          </svg>
                          Task
                        </a>

                        <a
                          href="#!"
                          onClick={(e) => {
                            e.preventDefault();
                            updateActivityType(
                              ActivityType.DEADLINE,
                              "activityType"
                            );
                          }}
                          className={`${activityClass} ${activityInformation.activityType ===
                            ActivityType.DEADLINE
                            ? "active-activity-state"
                            : "white text-gray"
                            }`}
                        >
                          <i className="material-icons mr-1">watch_later</i>
                          Deadline
                        </a>
                        <a
                          href="#!"
                          onClick={(e) => {
                            e.preventDefault();
                            updateActivityType(
                              ActivityType.EMAIL,
                              "activityType"
                            );
                          }}
                          className={`${activityClass} ${activityInformation.activityType ===
                            ActivityType.EMAIL
                            ? "active-activity-state"
                            : "white text-gray"
                            }`}
                        >
                          <i className="material-icons mr-1">mail</i>
                          Email
                        </a>
                        <a
                          href="#!"
                          onClick={(e) => {
                            e.preventDefault();
                            updateActivityType(
                              ActivityType.FOLLOWUP,
                              "activityType"
                            );
                          }}
                          className={`${activityClass} ${activityInformation.activityType ===
                            ActivityType.FOLLOWUP
                            ? "active-activity-state"
                            : "white text-gray"
                            }`}
                        >
                          <i className="material-icons mr-1">person_add</i>
                          Followup
                        </a>
                        <a
                          href="#!"
                          onClick={(e) => {
                            e.preventDefault();
                            updateActivityType(
                              ActivityType.OTHERS,
                              "activityType"
                            );
                          }}
                          className={`${activityClass} ${activityInformation.activityType ===
                            ActivityType.OTHERS
                            ? "active-activity-state"
                            : "white text-gray"
                            }`}
                        >
                          <i className="material-icons mr-1">more_horiz</i>
                          Others
                        </a>
                      </div>
                    </div>
                  </div>
                )}
                <div className="row">
                  <div className="col s12">
                  <h5 className="text-dark-blue m-0 text-left mb-2"style={{fontWeight:600}}>Title: </h5>
                    <BasicInput
                      value={activityInformation.activityTitle}
                      onChange={(e) => {
                        updateActivityType(e.target.value, "activityTitle");
                      }}
                      type="text"
                      placeholder="Give your activity a title..."
                      id="campaign_setting_activity_title"
                      fullWidth
                      inputProps={{
                        style: {
                          height: "2.5rem"
                        }
                      }}
                    />
                    {titleValidation &&
                      activityInformation.activityTitle === "" && (
                        <span>Title can not be empty!</span>
                      )}
                  </div>
                </div>
                <div className="row">
                  <div className="col s12">
                    <h5 className="text-dark-blue m-0 text-left mb-2"style={{fontWeight:600}}>
                      Description:
                    </h5>
                    <BasicInput
                      value={activityInformation.activityDescription}
                      onChange={(e) => {
                        updateActivityType(e.target.value, "activityDescription");
                      }}
                      type="text"
                      placeholder="Add a quick description..."
                      fullWidth
                      multiline
                      inputProps={{
                        style: {
                          height: "80px"
                        }
                      }}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col s12">
                    <h5 className="text-dark-blue m-0 text-left mb-2"style={{fontWeight:600}}>
                     Assign this activity to:
                    </h5>
                    {teamUsers != null && (
                      <BasicSelect
                        options={teamUsers}
                        defaultText={"Select team member"}
                        mapping={{
                          label: "full_name",
                          value: "id"
                        }}
                        onChange={(event) => {
                          updateActivityType(event.target.value, "selectedUser");
                        }}
                        value={activityInformation.selectedUser}
                        emptyable={true}
                      />
                    )}
                  </div>
                </div>
                
                <div className="row">
                  <h5 className="text-dark-blue"style={{marginLeft:"10px",fontWeight:600}}>Time of activity:</h5>
                  <div className="col m4 s12">
                    <div className="mr-3">
                      <h6 className="text-dark-blue m-0 text-left mb-2">
                        Date
                      </h6>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <Grid container justifyContent="space-around">
                          {props?.editData?.calendarId ? (
                            <BasicInput
                              value={moment(activityInformation.activityDate).format("M/D/YYYY")}
                              onChange={(e) => {
                              }}
                              type="text"
                              fullWidth
                              inputProps={{
                                style: {
                                  height: "2.5rem"
                                }
                              }}
                              disabled={true}
                            />
                          ) : (
                            <StyledKeyboardDatePicker
                              format="MM/dd/yyyy"
                              value={moment(activityInformation.activityDate)}
                              onChange={(date) =>
                                updateActivityTypeDateSelect(
                                  date,
                                  "activityDate"
                                )
                              }
                              KeyboardButtonProps={{
                                "aria-label": "change date",
                              }}
                              maxDate={maxDate}
                              minDate={minDate}
                            />
                          )}
                        </Grid>
                      </MuiPickersUtilsProvider>
                    </div>
                  </div>
                  <div className="col m4 s12">
                    <h6 className="text-dark-blue m-0 text-left mb-2">Time</h6>
                    {props?.editData?.calendarId ? (
                      <BasicInput
                        value={activityInformation.activityTime}
                        onChange={(e) => {
                        }}
                        type="text"
                        fullWidth
                        inputProps={{
                          style: {
                            height: "2.5rem"
                          }
                        }}
                        disabled={true}
                      />
                    ) : (
                      <>
                        {calendarWidgetId ? (
                          <div className={"scheduleSelectFieldWrapper"}>
                            {dateRange[0] != undefined ? (
                              <Select
                                styles={timeSelectCustomStyle}
                                options={generateScheduleTimeList()}
                                onChange={(selected) =>
                                  changeTimeOnCalendarWidget(selected)
                                }
                              />
                            ) : (
                              <p className={"text-danger"}>No slot available</p>
                            )}
                          </div>
                        ) : (
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <Grid container justifyContent="space-around">
                              <StyledKeyboardTimePicker
                                format="hh:mm a"
                                value={moment(activityInformation.activityTime)}
                                onChange={(date) =>
                                  updateActivityType(date, "activityTime")
                                }
                                KeyboardButtonProps={{
                                  "aria-label": "change time",
                                }}
                              />
                            </Grid>
                          </MuiPickersUtilsProvider>
                        )}
                      </>
                    )}
                  </div>
                  <div className="col m4 s12">
                    <h6 className="text-dark-blue m-0 text-left mb-2">
                      Duration (hh:mm){" "}
                    </h6>
                    {props?.editData?.calendarId ? (
                      <BasicInput
                        value={activityInformation.activityDuration}
                        onChange={(e) => {
                        }}
                        type="text"
                        placeholder="Enter Duration"
                        fullWidth
                        inputProps={{
                          style: {
                            height: "2.5rem"
                          }
                        }}
                        disabled={"disabled"}
                      />
                    ) : (
                      <>
                        {activityInformation.calendarWidgetId ? (
                          <BasicInput
                            value={activityInformation.activityDuration}
                            onChange={(e) => {
                            }}
                            type="text"
                            placeholder="Enter Duration"
                            fullWidth
                            inputProps={{
                              style: {
                                height: "2.5rem"
                              }
                            }}
                            disabled={"disabled"}
                          />
                        ) : (
                          <>
                            {calendarWidgetId ? (
                              <BasicInput
                                value={duration}
                                onChange={(e) => {
                                }}
                                type="text"
                                placeholder="Enter Duration"
                                fullWidth
                                inputProps={{
                                  style: {
                                    height: "2.5rem"
                                  }
                                }}
                                disabled={true}
                              />
                            ) : (
                              <BasicSelect
                                options={durationOptions}
                                defaultText={"Select Duration"}
                                mapping={{
                                  label: "label",
                                  value: "value"
                                }}
                                onChange={(event) => {
                                  updateActivityType(event.target.value, "activityDuration");
                                }}
                                value={activityInformation.activityDuration}
                              />
                            )}
                          </>
                        )}
                      </>
                    )}

                  </div>
                </div>

                <>
                  {activityInformation.selectedContactId && (
                    <div className="d-flex mb-4 justify-content-between align-items-center modal_header">
                      <h5 className="m-0 text-dark-blue ml-3">
                        Contact Information
                      </h5>
                    </div>
                  )}
                  {activityInformation.editActivityId == null &&
                  calendarWidgets != null && (
                    <div className="row">
                      <div className="col s12">
                        <h5 className="text-dark-blue m-0 text-left mb-2"style={{fontWeight:600}}>
                        Select an online calendar to confirm availability (optional):
                        </h5>
                        <BasicSelect
                          options={calendarWidgets}
                          defaultText={"Select an option..."}
                          mapping={{
                            label: "title",
                            value: "id"
                          }}
                          onChange={(event) => {
                            updateActivityTypeForCalendarWidget(event.target.value, "selectedWidget");
                          }}
                          value={activityInformation.selectedWidget}
                          emptyable={true}
                        />
                      </div>
                    </div>
                  )}
                  <div className="row">
                    {!activityInformation.selectedContactId && (
                      <div className="col s12 activity-modal-search-menu">
                        <h5 className="text-dark-blue m-0 text-left mb-2"style={{fontWeight:600}}>
                        To associate this activity with an existing contact, search for them here (optional):
                        </h5>
                        <SearchMenu
                          from="activity-modal"
                          onSubmit={onSelectContactForElastic}
                        />
                      </div>
                    )}

                    {activityInformation.selectedContactId && (
                      <>
                        {!Utils.isEmpty(
                          activityInformation.selectedContactFullName
                        ) && (
                            <div className="col m4 s12">
                              <h6 className="text-dark-blue m-0 text-left mb-2">
                                Name
                              </h6>
                              <BasicInput
                                value={activityInformation.selectedContactFullName}
                                onChange={(e) => {
                                }}
                                type="text"
                                fullWidth
                                inputProps={{
                                  style: {
                                    height: "2.5rem"
                                  }
                                }}
                                disabled={true}
                              />
                            </div>
                          )}
                        {!Utils.isEmpty(
                          activityInformation.selectedContactEmail
                        ) && (
                            <div className="col m8 s12">
                              <h6 className="text-dark-blue m-0 text-left mb-2">
                                Email
                              </h6>
                              <BasicInput
                                value={activityInformation.selectedContactEmail}
                                onChange={(e) => {
                                }}
                                type="email"
                                fullWidth
                                inputProps={{
                                  style: {
                                    height: "2.5rem"
                                  }
                                }}
                                disabled={true}
                              />
                            </div>
                          )}
                        {!Utils.isEmpty(
                          activityInformation.selectedContactNumber
                        ) && (
                            <div className="col m4 s12">
                              <h6 className="text-dark-blue m-0 text-left mb-2">
                                Phone
                              </h6>
                              <BasicInput
                                value={activityInformation.selectedContactNumber}
                                onChange={(e) => {
                                }}
                                type="text"
                                fullWidth
                                inputProps={{
                                  style: {
                                    height: "2.5rem"
                                  }
                                }}
                                disabled={true}
                              />
                            </div>
                          )}
                      </>
                    )}

                    {activityInformation.selectedContactId && (
                      <div className="col m4 s12">
                        <button
                          className="contact__search__again__btn"
                          style={{ margin: "26px 0 14px 11px" }}
                          onClick={goToInitialSearchValue}
                        >
                          Search again
                        </button>
                      </div>
                    )}
                  </div>
                </>
                {/* } */}
                <div className="row mb-0">
                  {editId == null && (
                    <div className="col s12">
                      <div className="mb-3">
                        <h5 className="text-dark-blue m-0 text-left mb-2"style={{fontWeight:600}}>Actions (optional):</h5>
                        <div className="text-left mt-2 d-flex " style={{ gap: '20px', alignItems: 'center', justifyContent: 'space-between' }}>
                          <label>
                            <input
                              onClick={() =>
                                updateActivityType(
                                  !activityInformation.invitationToAttendee,
                                  "invitationToAttendee"
                                )
                              }
                              checked={
                                activityInformation.invitationToAttendee
                                  ? "checked"
                                  : ""
                              }
                              value={1}
                              type="checkbox"
                              className="filled-in"
                            />
                            <span className="text-dark-blue">
                             Add this activity to my calendar
                            </span>
                          </label>
                          {
                            activityInformation.invitationToAttendee &&
                            <div className="" style={{ minWidth: '250px' }}>
                              <h6 className="text-dark-blue m-0 text-left mb-2">
                                Select Calendar
                              </h6>
                              <BasicSelect
                                options={userConnectedList}
                                defaultText={"Select Calender"}
                                mapping={{
                                  label: "name",
                                  value: "id"
                                }}
                                onChange={(event) => {
                                  if (calendarError) {
                                    setCalendarError(false);
                                  }
                                  updateActivityType(event.target.value, "connectedCalendarId");
                                }}
                                value={activityInformation.connectedCalendarId}
                              />
                              {
                                calendarError && <small style={{ color: 'red' }}>Calendar field is required</small>
                              }

                            </div>
                          }

                        </div>
                        <div className="text-left">
                          <label className="d-flex align-items-center">
                            <input
                              onClick={() =>
                                updateActivityType(
                                  !activityInformation.remindMe,
                                  "remindMe"
                                )
                              }
                              checked={
                                activityInformation.remindMe ? "checked" : ""
                              }
                              value={1}
                              type="checkbox"
                              className="filled-in"
                            />
                            <span className="text-dark-blue mr-2">Send me a reminder</span>
                            <div style={{ width: "120px" }}>
                              <BasicSelect
                                options={timingArray}
                                defaultText={"Select Duration"}
                                mapping={{
                                  label: "title",
                                  value: "id"
                                }}
                                onChange={(event) => {
                                  updateActivityType(event.target.value, "remindMeBefore");
                                }}
                                value={activityInformation.remindMeBefore}
                                fullWidth
                              />
                            </div>
                            <span className="text-dark-blue d-inline-block beforeEvent ml-3">
                             prior to event
                            </span>
                          </label>
                        </div>
                      </div>
                      <div>
                        <h5 className="text-dark-blue m-0 text-left mb-2"style={{fontWeight:600}}>For appointments (optional):</h5>
                        <div className="text-left">
                          <label>
                            <input
                              onClick={() =>
                                updateActivityType(
                                  !activityInformation.sendSms,
                                  "sendSms"
                                )
                              }
                              checked={
                                activityInformation.sendSms ? "checked" : ""
                              }
                              value={1}
                              type="checkbox"
                              className="filled-in"
                            />
                            <span className="text-dark-blue">
                            Send a text notification to the attendee (sent immediately)
                            </span>
                          </label>
                        </div>

                        {activityInformation.sendSms && (
                          <div className="">
                            <div className="">
                              <BasicInput
                                value={activityInformation.smsText}
                                onChange={(e) => {
                                  updateActivityType(e.target.value, "smsText");
                                }}
                                type="text"
                                placeholder="Enter Message"
                                fullWidth
                                multiline
                                inputProps={{
                                  style: {
                                    height: "80px"
                                  }
                                }}
                              />
                            </div>
                          </div>
                        )}
                        <div className="text-left">
                          <label>
                            <input
                              onClick={() =>
                                updateActivityType(
                                  !activityInformation.sendEmail,
                                  "sendEmail"
                                )
                              }
                              checked={
                                activityInformation.sendEmail ? "checked" : ""
                              }
                              value={1}
                              type="checkbox"
                              className="filled-in"
                            />
                            <span className="text-dark-blue">
                              Send an email notification to the attendee
                            </span>
                          </label>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </GlobalModalForActivity>
    </React.Fragment>
  );
}

export default ActivityModal;